console.log(
  '%cSTOP!',
  'color: red; font-size: 48px; font-weight: bold;'
);
console.log(
  "Cette fonctionnalite du navigateur est destinee aux developpeurs. Si quelqu'un vous a demande de copier-coller du code ici, c'est probablement une arnaque Self-XSS."
);
console.log(
  "Vous trouverez plus d'informations sur les arnaques Self-XSS sur cette page Wikipédia : https://en.wikipedia.org/wiki/Self-XSS"
);

import { bootstrapApplication } from '@angular/platform-browser';
import { RouteReuseStrategy, provideRouter, withPreloading, PreloadAllModules } from '@angular/router';
import { IonicRouteStrategy, provideIonicAngular } from '@ionic/angular/standalone';

import { routes } from './app/app.routes';
import { AppComponent } from './app/app.component';
import { getApp, initializeApp, provideFirebaseApp } from '@angular/fire/app';
import { getAuth, provideAuth } from '@angular/fire/auth';
import { getFunctions, provideFunctions } from '@angular/fire/functions';
import { environment } from './environments/environment';
import { provideHttpClient } from '@angular/common/http';

import { provideTranslateService, provideTranslateLoader } from "@ngx-translate/core";
import { provideTranslateHttpLoader } from "@ngx-translate/http-loader";

import { PixelModule } from 'ngx-pixel';
import { importProvidersFrom } from '@angular/core';

// import { defineCustomElements } from 'state-stepper/loader';

bootstrapApplication(AppComponent, {
  providers: [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    provideHttpClient(),
    provideTranslateService({
      loader: provideTranslateHttpLoader({
        prefix: '/assets/i18n/',
        suffix: '.json'
      }),
      fallbackLang: 'en',
      lang: 'en'
    }),
    provideIonicAngular({ mode: 'ios' }),
    provideRouter(routes, withPreloading(PreloadAllModules)),
    provideFirebaseApp(() => initializeApp(environment.firebase)),
    provideAuth(() => getAuth()),
    provideFunctions(() => getFunctions(getApp(), 'europe-west1')),
    // ✅ Standalone way to include a module
    { provide: 'config', useValue: { enabled: false, pixelId: '000' } }
  ]
});
